// SummerCampRegister/SummerCampReg.js
import SummerCampRegisterPage from ".";
import { NewUserContextProvider } from "../../APIContext/NewUserContext";
import { PlayerAccountProvider } from "../../APIContext/PlayerAccountContext";
import { SummerCampProvider } from "../../APIContext/summerCampContext";

const SummerCampRegister = () => {
  return (
    <SummerCampProvider>
      <PlayerAccountProvider>
        <NewUserContextProvider>
          {/* Add other providers here if needed */}
          <SummerCampRegisterPage />
        </NewUserContextProvider>
      </PlayerAccountProvider>
    </SummerCampProvider>
  );
};

export default SummerCampRegister;
